import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Subscription} from "rxjs";
import {HoverService} from '../../services/hover.service';

import {PercentUiControllerService} from "../../services/percent-ui-controller.service";
import {AnalyticsPercentBarComponent} from "../analytics-percent-bar/analytics-percent-bar.component";
import {CommonModule, CurrencyPipe} from "@angular/common";

@Component({
  selector: 'analytics-percent-ul',
  templateUrl: './analytics-percent-ul.component.html',
  imports: [
    CommonModule,
    AnalyticsPercentBarComponent,
    CurrencyPipe
  ],
  styleUrls: ['./analytics-percent-ul.component.css']
})
export class AnalyticsPercentUlComponent {
  @Output() idClicked: EventEmitter<string | undefined> = new EventEmitter<string | undefined>();
  selectedId?: number;
  mouseoverId?: number;

  subscription: Subscription = new Subscription();
  hoverId!: string
  selfIdentifier: string = "revenueDoughnutChartMakeUp";
  protected readonly onmouseup = onmouseup;

  constructor(private hoverService: HoverService,
              public percentUiControllerService: PercentUiControllerService) {
  }

  @Input("hoverModel") set hoverInput(hoverModel: { id: string, selfIdentifier: string }) {
    this.hoverId = hoverModel.id;
    this.selfIdentifier = hoverModel.selfIdentifier;
    this.subscribeToHover();
  }

  subscribeToHover() {
    this.subscription.add(this.hoverService.getEmitter(this.hoverId).subscribe((x: {
      datasetIndex: number,
      index: number,
      trigger: string
    }) => {
      if (x.trigger === this.selfIdentifier) return
      // todo: implement hover
      if (x.index !== this.selectedId) {
        this.selectedId = x.index;
      }


    }));
  }

  sendClick(id: number | undefined) {
    this.hoverService.getEmitter(this.hoverId).emit({datasetIndex: 0, index: id ?? -1, trigger: this.selfIdentifier});
  }

  /*mouseover(id: number | undefined) {
    this.mouseoverId = id;
  }*/

  /*mouseout(id: number | undefined) {
    //(mouseleave)="mouseover(undefined)"
    if(this.mouseoverId === id) {
      this.mouseoverId = undefined;
    }
  }
  */

  clicked(id: number) {

    this.selectedId = id === this.selectedId ? undefined : id;
    this.sendClick(this.selectedId);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
